import React from 'react';
import PropTypes from 'prop-types';
import { EntryPoint, EntryPointProp, EntryPointPropDefault } from '../../models';
import { SearchManager } from './SearchManager';
import { PixelTracking } from '../../components/PixelTracking';

const ConnectedTabManager = React.lazy(() =>
    import(/* webpackChunkName: "TabManagerDesktop" */ '../TabManager/TabManager').then((module) =>
        ({ default: module.ConnectedTabManager })));
const DynpackManagerDesktop = React.lazy(() =>
    import(/* webpackChunkName: "DynpackManagerDesktop" */ '../DynpackManager/DynpackManagerDesktop').then((module) =>
        ({ default: module.DynpackManagerDesktop })));
const FlightsManagerDesktop = React.lazy(() =>
    import(/* webpackChunkName: "FlightsManagerDesktop" */ '../FlightsManager/FlightsManagerDesktop').then((module) =>
        ({ default: module.FlightsManagerDesktop })));

export const SearchManagerDesktop = ({
    showTabs,
    entryPoint,
    isHotelOptionEnabled,
    wmpProductList,
    rootDataAttr,
}) => {
    const createManagerBlock = () => {
        return (entryPoint === EntryPoint.DP) ?
            <DynpackManagerDesktop /> : (
                <FlightsManagerDesktop
                    isHotelOptionEnabled={isHotelOptionEnabled}
                    rootDataAttr={rootDataAttr}
                />
            );
    };

    return (
        <SearchManager>
            <PixelTracking entryPoint={entryPoint} />
            {showTabs ?
                <ConnectedTabManager wmpProductList={wmpProductList} rootDataAttr={rootDataAttr} entryPoint={entryPoint} /> : createManagerBlock()
            }
        </SearchManager>
    );
};

SearchManagerDesktop.propTypes = {
    showTabs: PropTypes.bool,
    isHotelOptionEnabled: PropTypes.bool,
    entryPoint: EntryPointProp,
    wmpProductList: PropTypes.string,
    rootDataAttr: PropTypes.object,
};

SearchManagerDesktop.defaultProps = {
    showTabs: false,
    isHotelOptionEnabled: false,
    entryPoint: EntryPointPropDefault,
    wmpProductList: '',
    rootDataAttr: {}
};
